import React from 'react';

export const TimePeriodSelector = ({ selectedPeriod, onPeriodChange }) => {
  const periods = [
    { value: 'DAY', label: 'Day' },
    { value: 'MONTH', label: 'Month' },
    { value: '3MONTHS', label: '3 Months' },
    { value: 'ALL', label: 'All Time' }
  ];

  return (
    <div className="flex space-x-2">
      {periods.map((period) => (
        <button
          key={period.value}
          onClick={() => onPeriodChange(period.value)}
          className={`px-4 py-2 text-sm font-medium rounded transition-colors duration-200 ${
            selectedPeriod === period.value
              ? 'bg-blue-500 text-white'
              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
          }`}
        >
          {period.label}
        </button>
      ))}
    </div>
  );
};